<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <v-menu
      v-model="showMenu"
      class="menu-style-task"
      top
      right
      min-width="100%"
      max-width="100%"
      max-height="400px"
      :position-x="xShowPosition"
      :position-y="yShowPosition"
      absolute
      :style="{ 'background-color': 'white' }"
    >
      <!-- <v-card-subtitle
        class="font-weight-bold text-2xl"
        :style="{ 'background-color': 'whitesmoke' }"
        >AI可以帮你做:</v-card-subtitle
      > -->
      <v-subheader light :style="{ 'background-color': 'whitesmoke' }"
        >请选择类型:</v-subheader
      >
      <v-list>
        <v-list-item
          v-for="menu in pptOptionMenus"
          :key="menu.id"
          @click="onSelectMenu(menu)"
        >
          <v-list-item-content>
            <v-list-item-subtitle class="text-xs">{{
              menu.title
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { get } from "vuex-pathify";

//例如: import <组件名称> from  <组建路径>

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      showMenu: false,
      xShowPosition: 0,
      yShowPosition: 0,
    };
  },
  //计算机属性 类似与data概念
  computed: {
    ...get("gpt", ["pptOptionMenus"]),
  },
  //监控data中数据变化
  watch: {},
  methods: {
    funcShowMenu() {
      this.showMenu = true;
      this.xShowPosition = 0;
      this.yShowPosition = document.body.clientHeight; // 加上AppBar的高度
    },
    onSelectMenu(menu) {
      this.$emit("onClickMenu", menu);
      this.showMenu = false;
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {},
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
